import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomDotCmsContentlet } from 'src/app/extensions/dot-cms/models/contentlet/custom-dotcms-contentlet.model';
import { tryProcessVideo } from 'src/app/extensions/dot-cms/utils/dot-cms-utils';

@Component({
  selector: 'custom-dot-cms-block-editor-video',
  templateUrl: './dot-cms-block-editor-video.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotCmsBlockEditorVideoComponent implements OnInit {
  content!: CustomDotCmsContentlet;
  constructor(private sanitizer: DomSanitizer) {}
  ngOnInit(): void {
    this.iframeVideoUrl(this.content);
  }
  iframeVideoUrl(contentlet: CustomDotCmsContentlet) {
    return tryProcessVideo(contentlet, this.sanitizer);
  }
}
